import type { ReactNode } from 'react';
import { Info } from 'lucide-react';

// A small ⓘ next to a label: the explanation shows on hover or keyboard focus
// instead of sitting in the page as a paragraph. The bubble stays open while
// hovered, so it can hold a link.
export function InfoTip({ children, label, align = 'start' }: {
  children: ReactNode;
  /** Accessible name of the icon (defaults to the bubble's text when it is a string). */
  label?: string;
  align?: 'start' | 'end';
}) {
  return (
    <span className={`info-tip info-tip--${align}`} tabIndex={0} aria-label={label ?? (typeof children === 'string' ? children : undefined)}>
      <Info size={12} aria-hidden />
      <span className="info-tip-bubble" role="tooltip">{children}</span>
    </span>
  );
}
